// src/utils/imageLoader.js

const importAll = (requireContext) => {
    let images = {};
    requireContext.keys().forEach((item) => {
        images[item.replace('./', '')] = requireContext(item);
    });
    return images;
};

const images = importAll(require.context('../assets/Images', true, /\.(png|jpe?g|webp)$/));

// Las evidencias subidas desde el panel llegan como URL absoluta (/uploads/...);
// las del código, como ruta relativa a src/assets/Images.
export const resolveImage = (src) => (src && src.startsWith("/") ? src : images[src]);

export default images;
